<template>
    <div v-if="section"
         :id="sectionElementId"
         :class="[
        'ufo-sec',
        `ufo-sec--${getSectionType()}`,
        layoutTypeClass,
        contentSettingsClasses,
        ]"
         :style="sectionStyle"
    >
        <ToggleGrid />
        <SectionBackground v-if="!hideBackgroundImage" :section="section" />
        <div class="grid-wrapper">
            <div class="grid">
                <slot />
            </div>
        </div>
    </div>
</template>

<script>
    import ToggleGrid from "@/scripts/common/components/ToggleGrid.vue";
    import SectionBackground from "@/scripts/sections/common/SectionBackground.vue";
    import {updateSectionLevelColorCssInHead} from "@/scripts/common/TextStyleRenderHelper.js";
    import {SectionTypesEnum} from "@/scripts/common/enums.js";

    export default {
        name: "SectionBase",
        components: {SectionBackground, ToggleGrid},
        props: {
            section: {
                type: Object,
                required: true
            },
            sectionStyle: {
                type: Object,
                default: null
            },
            hideBackgroundImage: {
                type: Boolean,
                default: false
            }
        },
        beforeMount() {
            if(!this.$route.query.templatePreview) {
                updateSectionLevelColorCssInHead(this.section)
            }
        },
        computed: {
            sectionElementId() {
                return this.section?._id ? `section-${this.section._id}` : null;
            },
            layoutTypeClass() {
                const layoutType = this.section?.layoutSettings?.layoutType;
                if (!layoutType) return null;
                return `layout-${layoutType.toString().replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()}`;
            },
            contentSettingsClasses() {
                return {
                    'legacy-inset-text-box': this.section?.contentSettings?.legacyInsetTextBox === true,
                };
            },
        },
        methods: {
            getSectionType() {
                if(this.section.type === "TextAndMedia") {
                    const showText = this.section.contentSettings?.showText
                    const showMedia = this.section.contentSettings?.showMedia 
                    
                    if(showText === true && showMedia === true) {
                        return "textandmedia"
                    } else if(showText === false && showMedia === true) {
                        return "media"
                } else if(showText === true && showMedia === false) {
                    return "text"
                } else {
                    return "textandmedia"
                }
                } else {
                    return this.section.type.toLowerCase()
                }
            },
        }
    }
</script>
